import { CustomDrawerComponent } from './custom-drawer-content/custom-drawer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomDrawerContainerComponent } from './custom-drawer-container/custom-drawer-container.component';



@NgModule({
  declarations: [
    CustomDrawerContainerComponent,
    CustomDrawerComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CustomDrawerContainerComponent,
    CustomDrawerComponent,
  ]
})
export class CustomDrawerModule { }
